import {
  ContractTerm,
  ContractTermCostTierId,
  ContractTermsFormValues,
} from 'pricing/types';
import { apiContract } from 'utilities/http/api/pricing/apiContract';

export const contractTermEdit = async (
  contractTermFormValues: ContractTermsFormValues,
  editContractTerm: ContractTerm,
  isAmendment = false,
): Promise<ContractTerm> => {
  const getContractTermCostId = (ContractTermCostTierId: number) => {
    return editContractTerm.costs.find(
      (cost) => cost.breederContractTermCostTierId === ContractTermCostTierId,
    )?.id;
  };

  const contractTermPayload = {
    isAmendment,
    contractTerm: {
      quantity: contractTermFormValues.quantity,
      breedId: contractTermFormValues.breedId,
      colorIds: contractTermFormValues.colorIds,
      varietyIds: contractTermFormValues.varietyIds,
      breederContractTermTypeId: contractTermFormValues.breederContractTermTypeId,
      costs: [
        {
          id: getContractTermCostId(ContractTermCostTierId.Initial),
          cost: contractTermFormValues.initialCost,
          price: contractTermFormValues.initialPrice,
        },
        {
          id: getContractTermCostId(ContractTermCostTierId.Decreased),
          cost: contractTermFormValues.middleCost,
          price: contractTermFormValues.middlePrice,
        },
        {
          id: getContractTermCostId(ContractTermCostTierId.Final),
          cost: contractTermFormValues.finalCost,
          price: contractTermFormValues.finalPrice,
        },
      ],
    },
  };

  const respContractTerm = await apiContract.putContractTerm(
    editContractTerm.id,
    contractTermPayload,
  );

  if (!respContractTerm.isOk) {
    throw Error(respContractTerm.json?.message || `Couldn't edit contract term`);
  }

  return respContractTerm.json.contractTerm;
};
